import Login from './views/Login.vue';
import wechat from './views/wechat-login.vue';
import NotFound from './views/404.vue';
import Home from './views/Home.vue';

import Admin from './views/admin/index.vue';
import Hotel from './views/hotel/index.vue';
import Audit from './views/audit/index.vue';
import Order from './views/order/index.vue';
import Book from './views/order/book.vue';
import Cookie from './views/cookie';
import Statistic from './views/order/statistic';
import Template from './views/template'
import Settle from './views/order/settle';
// import Compass from './views/compass/index.vue'

import echarts from './views/charts/echarts.vue';

let routes = [
  {
    path: '/login',
    component: Login,
    name: '',
    hidden: true,
  },
  {
    path: '/wechat-login',
    component: wechat,
    name: '',
    hidden: true,
  },
  {
    path: '/404',
    component: NotFound,
    name: '',
    hidden: true,
  },
  //{ path: '/main', component: Main },
  // {
  //   path: '/',
  //   component: Home,
  //   name: '导航一',
  //   iconCls: 'el-icon-message', //图标样式class
  //   children: [
  //     { path: '/main', component: Main, name: '主页', hidden: true },
  //     { path: '/table', component: Table, name: 'Table' },
  //     { path: '/form', component: Form, name: 'Form' },
  //     { path: '/user', component: user, name: '列表' },
  //   ],
  // },
  // {
  //   path: '/',
  //   component: Home,
  //   name: '导航二',
  //   iconCls: 'fa fa-id-card-o',
  //   children: [
  //     { path: '/page4', component: Page4, name: '页面4' },
  //     { path: '/page5', component: Page5, name: '页面5' },
  //   ],
  // },
  {
    path: '/',
    component: Home,
    name: '',
    iconCls: 'fa fa-address-card',
    leaf: true, //只有一个节点
    children: [{ path: '/hotel', component: Hotel, name: '酒店管理' }],
  },
  {
    path: '/',
    component: Home,
    name: '',
    iconCls: 'fa fa-address-card',
    leaf: true, //只有一个节点
    children: [{ path: '/audit', component: Audit, name: '审核管理' }],
  },
  {
    path: '/',
    component: Home,
    name: '',
    iconCls: 'fa fa-address-card',
    leaf: true, //只有一个节点
    children: [{ path: '/book', component: Book, name: '预定管理' }],
  },
  {
    path: '/',
    component: Home,
    name: '',
    iconCls: 'fa fa-address-card',
    leaf: true, //只有一个节点
    children: [{ path: '/order', component: Order, name: '订单管理' }],
  },
  {
    path: '/',
    component: Home,
    name: '',
    iconCls: 'fa fa-address-card',
    leaf: true, //只有一个节点
    children: [{ path: '/statistic', component: Statistic, name: '数据统计' }],
  },
  // {
  //   path: '/',
  //   component: Home,
  //   name: '',
  //   iconCls: 'fa fa-address-card',
  //   leaf: true, //只有一个节点
  //   children: [{ path: '/compass', component: Compass, name: '数据罗盘' }],
  // },
  {
    path: '/',
    component: Home,
    name: '',
    iconCls: 'fa fa-address-card',
    leaf: true, //只有一个节点
    children: [{ path: '/template', component: Template, name: '房态管理' }],
  },
  // {
  //   path: '/',
  //   component: Home,
  //   name: '',
  //   iconCls: 'fa fa-address-card',
  //   leaf: true, //只有一个节点
  //   children: [{ path: '/settle', component: Settle, name: '提现管理' }],
  // },
  {
    path: '/',
    component: Home,
    name: '系统管理',
    iconCls: 'fa fa-address-card',
    leaf: false, //只有一个节点
    children: [
      { path: '/admin', component: Admin, name: '管理员' },
      { path: '/cookie', component: Cookie, name: '更新cookie' },
    ],
  },

  // {
  //   path: '/',
  //   component: Home,
  //   name: 'Charts',
  //   iconCls: 'fa fa-bar-chart',
  //   children: [{ path: '/echarts', component: echarts, name: 'echarts' }],
  // },
  {
    path: '*',
    hidden: true,
    redirect: { path: '/404' },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js